var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass: "editor-style-settings-mask",
      on: {
        click: function ($event) {
          if ($event.target !== $event.currentTarget) return null
          return _vm.handleCancel.apply(null, arguments)
        },
      },
    },
    [
      _c("div", { staticClass: "editor-style-settings-dialog" }, [
        _c("header", { staticClass: "editor-style-settings-header" }, [
          _c("h1", [_vm._v(_vm._s(_vm.$t("editorStyleSettingsModal.title")))]),
          _c(
            "button",
            {
              staticClass: "close-button",
              attrs: {
                type: "button",
                "aria-label": _vm.$t("editorStyleSettingsModal.closeAriaLabel"),
              },
              on: { click: _vm.handleCancel },
            },
            [_vm._v("×")]
          ),
        ]),
        _c("div", { staticClass: "editor-style-settings-body" }, [
          _c(
            "div",
            { staticClass: "editor-style-settings-form" },
            [
              _c("slider-input", {
                attrs: {
                  label: _vm.$t("editorStyleSettingsModal.fontSize"),
                  value: _vm.formFontSize,
                  min: _vm.limits.fontSize.min,
                  max: _vm.limits.fontSize.max,
                  step: 0.1,
                  unit: "pt",
                },
                on: { input: _vm.updateFontSize },
              }),
              _c("slider-input", {
                attrs: {
                  label: _vm.$t("editorStyleSettingsModal.lineHeight"),
                  value: _vm.formLineHeight,
                  min: _vm.limits.lineHeight.min,
                  max: _vm.limits.lineHeight.max,
                  step: 0.1,
                },
                on: { input: _vm.updateLineHeight },
              }),
              _c("slider-input", {
                attrs: {
                  label: _vm.$t("editorStyleSettingsModal.letterSpacing"),
                  value: _vm.formLetterSpacing,
                  min: _vm.limits.letterSpacing.min,
                  max: _vm.limits.letterSpacing.max,
                  step: 0.1,
                  unit: "pt",
                },
                on: { input: _vm.updateLetterSpacing },
              }),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "editor-style-settings-preview",
              style: _vm.previewStyle,
            },
            [_vm._v(" " + _vm._s(_vm.sampleText) + " ")]
          ),
        ]),
        _c("footer", { staticClass: "editor-style-settings-footer" }, [
          _c(
            "button",
            {
              staticClass: "button secondary",
              attrs: { type: "button" },
              on: { click: _vm.handleReset },
            },
            [
              _vm._v(
                " " +
                  _vm._s(_vm.$t("editorStyleSettingsModal.resetToDefault")) +
                  " "
              ),
            ]
          ),
          _c(
            "button",
            {
              staticClass: "button primary",
              attrs: { type: "button" },
              on: { click: _vm.handleApply },
            },
            [
              _vm._v(
                " " + _vm._s(_vm.$t("editorStyleSettingsModal.apply")) + " "
              ),
            ]
          ),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }